.Text3127536861__root {
    -st-states:
            size(enum(tiny, small, medium, large)),
            weight(enum(thin, normal, bold)),
            skin(enum(standard, placeholder, premium, alert, success, link, secondary, standard-light, secondary-light)),
            disabled;
}

/* Size */
.Text3127536861__root.Text3127536861---size-4-tiny {
  font-size: 12px;
  line-height: 18px;
}

.Text3127536861__root.Text3127536861---size-5-small {
  font-size: 14px;
  line-height: 18px;
}

.Text3127536861__root.Text3127536861---size-6-medium {
  font-size: 16px;
  line-height: 24px;
}

.Text3127536861__root.Text3127536861---size-5-large {
  font-size: 18px;
  line-height: 24px;
}

/* Weight */
.Text3127536861__root.Text3127536861---weight-4-thin {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography1118566619-wix-font-weight-regular, 400);
  -webkit-font-smoothing: antialiased;
}

.Text3127536861__root.Text3127536861---weight-6-normal {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography1118566619-wix-font-weight-medium, 530);
  -webkit-font-smoothing: antialiased;
}

.Text3127536861__root.Text3127536861---weight-4-bold {
  font-family: var(--wbu-font-stack, HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--Typography1118566619-wix-font-weight-bold, 700);
  -webkit-font-smoothing: antialiased;
}

/* Skin */
.Text3127536861__root.Text3127536861---skin-8-standard {
     color: #000624;
}

.Text3127536861__root.Text3127536861---skin-14-standard-light {
     color: #fff;
}

.Text3127536861__root.Text3127536861---skin-11-placeholder {
     color: #acafc4;
}

.Text3127536861__root.Text3127536861---skin-7-premium {
     color: #9a27d5;
}

.Text3127536861__root.Text3127536861---skin-5-alert {
     color: #e62214;
}

.Text3127536861__root.Text3127536861---skin-7-success {
     color: #25a55a;
}

/* TODO - remove in favor of TextButton */
.Text3127536861__root.Text3127536861---skin-4-link {
     color: #116dff;
}

.Text3127536861__root.Text3127536861---skin-9-secondary {
     color: #3b4057;
}

.Text3127536861__root.Text3127536861---skin-15-secondary-light {
     color: #dfe5eb;
}

.Text3127536861__root.Text3127536861--disabled {
  color: #898989;
}

/* st-namespace-reference="../../../../src/atoms/Text/Text.st.css" */